import AutomationForm from './AutomationForm';

export default AutomationForm;
